module.exports = __webpack_public_path__ + "static/media/landing-5.51270a56.jpg";